module.exports = __webpack_public_path__ + "static/media/discover.c1a07aea.png";